import { PropsWithChildren } from "react";

import "./DefaultStyleSection.css";

export default function DefaultStyleSection({ children }: PropsWithChildren) {
  return <div className="default-style">{children}</div>;
}
